///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_import_items = abcsetup.rx_import_items || {};
abcsetup.rx_import_items.load_data = abcsetup.rx_import_items.load_data || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_import_items.load_data = {
    init: function() {

        // Show the add item modal
        $('#select_all').click(function() {
            if ($(this).is(':checked')) {
                $('.checkbox-row').attr('checked', true);
            }
            else {
                $('.checkbox-row').attr('checked', false);
            }
            
        });
    },
}
